var MutationObserver = require('mutation-observer');

(function() {
    const introBg = document.querySelector('#introBackground');
    const slideLinks = Array.from(document.querySelectorAll('.slide__copy a'));
    const slideImages = Array.from(document.querySelectorAll('.slide__image img'));

    function changeBg(el, className) {

        el.addEventListener('mouseover', function (event) {
            event.stopPropagation();

            if (event.target.classList.contains(className)) {
                introBg.style.backgroundImage = `url("http://gardelina.ro/assets/img/${className}.jpg")`;
            }
        });

        el.addEventListener('mouseout', () => {
            introBg.style.backgroundImage = 'url("http://gardelina.ro/assets/img/hero-bg-1.jpg")';
        });
    }

    slideImages.forEach((slideImage) => {
        var modifierName = slideImage.className;
        changeBg(slideImage, modifierName);
    });

    slideLinks.forEach((slideLink) => {
        var modifierName = slideLink.className;
        changeBg(slideLink, modifierName);
    });

    // Select the node that will be observed for mutations
   var target = Array.from(document.getElementsByClassName('glide__slide')).filter((slide) => {
        return slide.classList.contains('glide__slide--active');
   });

   // Options for the observer (which mutations to observe)
    var config = { attributes: true, childList: false, subtree: false };

    // Callback function to execute when mutations are observed
    var callback = function(mutationList, observer) {
        for(var mutation of mutationList) {
            const el = mutation.target;

            if(mutation.type == 'childList') {
                console.log('A child node has been added or removed');
            }
            else if (mutation.type == "attributes" && mutation.target.classList.contains('glide__slide--active') && mutation.target.classList.contains('motopompe')) {
               document.querySelector('#introBackground').classList.add('motompe');
               console.log('motopompe')
            }
            else if (mutation.type == "attributes" && mutation.target.classList.contains('glide__slide--active') && mutation.target.classList.contains('aparate-de-stropit')) {
               document.querySelector('#introBackground').classList.add('aparate-de-stropit');
               console.log('aparate');
            }
        }
    }
    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(target[0],config);
}());



// WEBPACK FOOTER //
// ./src/js/module/intro.js